module.exports = "/src/views/player/help/images/azart1.jpg";